module.exports = __webpack_public_path__ + "img/icon_deposit_withdraw.94d16b67.png";